import { render, staticRenderFns } from "./customerRetention.vue?vue&type=template&id=0400a592&"
import script from "./customerRetention.vue?vue&type=script&lang=ts&"
export * from "./customerRetention.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports